module.exports = __webpack_public_path__ + "media/images/flags/4x3/gum-63700bdd961ab128810a7d3fb7f2a4ec.svg";